import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

export default defineNuxtPlugin(() => {
  const {
    DD_APP_ID,
    DD_CLIENT_TOKEN,
    DD_SITE,
    DD_SERVICE,
    DD_ENV,
    DD_TRACING_URLS,
  } = useRuntimeConfig().public

  const allowedTracingUrls = (DD_TRACING_URLS as string || '').split(',')
    .map(url => url.trim())
    .map(u => (url: string) => url.startsWith(u))

  datadogRum.init({
    applicationId: DD_APP_ID as string,
    clientToken: DD_CLIENT_TOKEN as string,
    // // `site` refers to the Datadog site parameter of your organization
    // // see https://docs.datadoghq.com/getting_started/site/
    site: DD_SITE as string,
    service: DD_SERVICE as string,
    env: DD_ENV as string,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls,
  })
  datadogLogs.init({
    clientToken: DD_CLIENT_TOKEN as string,
    site: DD_SITE as string,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['log', 'error'],
    sessionSampleRate: 100,
    service: DD_SERVICE as string,
    env: DD_ENV as string,
  })

  return {
    provide: {
      datadogRum,
      datadogLogs,
    },
  }
})
